// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import {
  listAdminUsersApiAdminUsersGet,
  createAdminUserApiApiAdminUsersPost,
  getAdminUserDetailApiAdminUsersUserIdGet,
  updateAdminUserApiApiAdminUsersUserIdPut,
  deleteAdminUserApiApiAdminUsersUserIdDelete,
  resetAdminUserPasswordApiApiAdminUsersUserIdPasswordPut,
} from './generated/adminUser';

/**
 * 管理端用户登录
 * POST /api/admin/users/login
 */
export async function adminLogin(
  body: API.AdminLoginRequest,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponse<API.AdminLoginResponse>>(
    '/api/admin/users/login',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/**
 * 获取当前管理端用户信息
 * GET /api/admin/users/me
 */
export async function getCurrentAdminUser(
  options?: { [key: string]: any },
) {
  return request<API.BaseResponse<API.AdminUserResponse>>(
    '/api/admin/users/me',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 更新个人信息
 * PUT /api/admin/users/me
 */
export async function updateProfile(
  body: API.UpdateProfileRequest,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponse<API.AdminUserResponse>>(
    '/api/admin/users/me',
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/**
 * 修改密码
 * PUT /api/admin/users/me/password
 */
export async function changePassword(
  body: API.ChangePasswordRequest,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponse<Record<string, any>>>(
    '/api/admin/users/me/password',
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/**
 * 生成 Telegram 绑定链接
 * GET /api/admin/users/me/bind-telegram-link
 */
export async function generateBindTelegramLink(
  options?: { [key: string]: any },
) {
  return request<API.BaseResponse<API.BindTelegramLinkResponse>>(
    '/api/admin/users/me/bind-telegram-link',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 查询绑定的 Telegram 用户信息
 * GET /api/admin/users/me/telegram-user
 */
export async function getTelegramUserInfo(
  options?: { [key: string]: any },
) {
  return request<API.BaseResponse<API.TelegramUserInfoResponse>>(
    '/api/admin/users/me/telegram-user',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

// ============ 员工管理（管理端用户 CRUD，仅 admin 角色可调用） ============

/**
 * 后台用户列表（分页）
 * GET /api/admin/users
 */
export async function listAdminUsers(
  params: API.listAdminUsersApiAdminUsersGetParams,
  options?: { [key: string]: any },
) {
  return listAdminUsersApiAdminUsersGet(params, options);
}

/**
 * 创建后台用户
 * POST /api/admin/users
 */
export async function createAdminUser(
  body: API.CreateAdminUserRequest,
  options?: { [key: string]: any },
) {
  return createAdminUserApiApiAdminUsersPost(body, options);
}

/**
 * 获取后台用户详情
 * GET /api/admin/users/:user_id
 */
export async function getAdminUser(
  userId: string,
  options?: { [key: string]: any },
) {
  return getAdminUserDetailApiAdminUsersUserIdGet({ user_id: userId }, options);
}

/**
 * 更新后台用户
 * PUT /api/admin/users/:user_id
 */
export async function updateAdminUser(
  userId: string,
  body: API.UpdateAdminUserRequest,
  options?: { [key: string]: any },
) {
  return updateAdminUserApiApiAdminUsersUserIdPut(
    { user_id: userId },
    body,
    options,
  );
}

/**
 * 删除后台用户（软删除）
 * DELETE /api/admin/users/:user_id
 */
export async function deleteAdminUser(
  userId: string,
  options?: { [key: string]: any },
) {
  return deleteAdminUserApiApiAdminUsersUserIdDelete(
    { user_id: userId },
    options,
  );
}

/**
 * 重置后台用户密码（仅 admin 可调用）
 * PUT /api/admin/users/:user_id/password
 */
export async function resetAdminUserPassword(
  userId: string,
  body: API.ResetAdminUserPasswordRequest,
  options?: { [key: string]: any },
) {
  return resetAdminUserPasswordApiApiAdminUsersUserIdPasswordPut(
    { user_id: userId },
    body,
    options,
  );
}
